module.exports = __webpack_public_path__ + "img/09.c6952889.png";